import { Link } from "react-router-dom";
import footerLogo from "../../assets/image/svg/Logo.svg"
import facebookIcon from "../../assets/image/svg/facebookIcon.svg"
import instagramIcon from "../../assets/image/svg/instagramIcon.svg"
import tiwtterIcon from "../../assets/image/svg/Vector.svg"


export default function Footer() {
  
  return (
    <div className="bg-Footer px-2 px-sm-0">
        
      <div className="container ">
        <div className="row  pt-5">
          <div className="col-lg-4 col-sm-6   offset-md-0 col-12">
            <div className="">
              <img className="footerLogo" src={footerLogo} alt="footerLogo" />
            </div>
            <p style={{color:"#737373",fontSize:"15px"}} href="#learn" className=" NAV-LINK fw-normal mt-4" >
              Book car care, salons, spas, sports grounds, and restaurants across Dubai all in one app. 
            </p>
            <p style={{color:"#737373",fontSize:"15px"}} href="#learn" className=" NAV-LINK fw-normal mt-2" >
              Vasta makes it simple to find, compare, and book trusted local businesses near you. 
            </p>
          <div className="d-flex gap-2 mt-3 align-items-center">
            <img style={{cursor:"pointer"}} width={25} height={25} src={facebookIcon} alt="facebookIcon" />
            <img style={{cursor:"pointer"}} width={25} height={25} src={instagramIcon} alt="facebookIcon" />
            <img style={{cursor:"pointer"}} width={20} height={20} src={tiwtterIcon} alt="facebookIcon" />
          </div>
          </div>
          <div className="col-lg-3 col-6 mt-4 mt-lg-0 offset-md-0 ">
            <div>
              <ul className="LIST ps-md-5 ms-md-5 p-0">
                <h4 className="clr my-2 pb-1 fw-bold " style={{fontSize:"20px"}}>Quick Links</h4>
                <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}} href="#learn" className=" NAV-LINK fw-medium">Overview</a>
                </li>
                <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="#service">Features</a>
                </li>
                <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="#howitwork">How It Works </a>
                </li>
                <li style={{listStyle:"none"}} className="py-2 ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="#downloadLink">Download App</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-6 mt-4 mt-lg-0 offset-md-0 ">
            <div>
               <div className="ps-md-5">
             
                <h4 className="clr my-2 pb-1 fw-bold " style={{fontSize:"20px"}}>Legal</h4>
               <Link style={{textDecoration:"none"}} to="/about"> <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}} href="#learn" className=" NAV-LINK fw-medium">About Us</a>
                </li></Link>
               <Link style={{textDecoration:"none"}} to="/privacy-policy"> <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="#resourses">Privacy Policy</a>
                </li></Link>
               <Link style={{textDecoration:"none"}} to="/terms-conditions">   <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="/terms-conditions">Terms & Conditions </a>
                </li></Link>
               <Link style={{textDecoration:"none"}} to="/contact-us">   <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="/contact-us">Contact Us </a>
                </li></Link>
                
              
             
            </div>
              
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 offset-md-0 col-12">
               <div>
           
                <h4 className="clr my-2 pb-1 fw-bold " style={{fontSize:"20px"}}>Services</h4>
               
                <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="#resourses">Men’s Salon</a>
                </li>
                <li style={{listStyle:"none"}} className="py-2  ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="/privacy-policy">Women’s Salon </a>
                </li>
                <li style={{listStyle:"none"}} className="py-2 ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="/terms-of-use">Automotive Care</a>
                </li>
                <li style={{listStyle:"none"}} className="py-2 ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="/terms-of-use">Sports</a>
                </li>
                <li style={{listStyle:"none"}} className="py-2 ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="/terms-of-use">Restaurants</a>
                </li>
                <li style={{listStyle:"none"}} className="py-2 ">
                  <a style={{color:"#737373",fontSize:"14px"}}  className=" NAV-LINK fw-medium" href="/terms-of-use">Health & Wellness</a>
                </li>
              
            </div>
          
          </div>
         
        </div>
      </div>
       <div className="col-12 footerLine   mt-5  py-4">
            <p style={{color:"#737373",fontSize:"14px"}} href="#learn" className=" NAV-LINK mb-0 fw-medium text-center" >
              © 2025 Vasta Technologies. All rights reserved.
            </p>
          
          </div>
    </div>
  );
}
